import { useCallback } from 'react';
import { useWorkFlowCanvas } from '../../../../contexts/CampaignFlowProvider';
import { Canvas } from 'sections/onsite-campaigns/pages/CampaignEditor/domain/Canvas/Canvas';
import { useBranches } from '../../../../state/Branches/hooks/useBranches';

export const useOnBranchesOrganised = () => {
  const { state, dispatch } = useWorkFlowCanvas();
  const { organiseBranches } = useBranches();

  return useCallback(
    (controlNodeId: string, ids: string[]) => {
      const { nodes, edges } = Canvas.createFromState(state)
        .reOrderBranches(controlNodeId, ids)
        .convertToState();

      const controlNode = nodes.find(s => s.id === controlNodeId);
      organiseBranches(nodes.filter(s => controlNode.data.children.includes(s.id)).map(s => s.id));

      dispatch({
        type: 'UPDATE',
        payload: { nodes, edges },
      });
    },
    [dispatch, organiseBranches, state],
  );
};
